import {
  BOOKING_ADD_ITEM,
  BOOKING_REMOVE_ITEM,
  BOOKING_SAVE_PAYMENT_METHOD,
  BOOKING_SAVE_DELIVERY_ADDRESS,
} from "../constants/bookingConstants";

export const bookingReducer = (state = { bookingItems: [] }, action) => {
  switch (action.type) {
    case BOOKING_ADD_ITEM:
      // item to be added into booking
      const item = action.payload;

      // check if item already in booking
      const existItem = state.bookingItems.find(
        (x) => x.product === item.product
      );

      if (existItem) {
        // exist
        return {
          ...state,
          bookingItems: state.bookingItems.map((x) =>
            x.product === existItem.product ? item : x
          ),
        };
      } else {
        // doestn't exist
        return {
          ...state,
          bookingItems: [...state.bookingItems, item],
        };
      }
    case BOOKING_REMOVE_ITEM:
      return {
        ...state,
        bookingItems: state.bookingItems.filter(
          (x) => x.product !== action.payload
        ),
      };

    case BOOKING_SAVE_DELIVERY_ADDRESS:
      return {
        ...state,
        deliveryAddress: action.payload,
      };
    case BOOKING_SAVE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      };

    default:
      return state;
  }
};
